<template>
    <div class="toggle-block">
        <div :class="classBindings" @click="toggle">
            <div class="toggle-indicator"></div>
        </div>
        <div class="label">
            {{label}}
        </div>
    </div>
</template>

<script>
export default {
    props: {
        value: Boolean,
        label: String
    },
    methods: {
        toggle() {
            this.$emit('toggle');
        }
    },
    computed: {
        classBindings() {
            return {
                toggle: true,
                active: this.value
            }
        }
    }
};
</script>

<style lang="scss" scoped>
@import "../../scss/abstracts/variables";


.toggle-block {
    display: flex;
    flex-direction: row;
    align-items: center;

    @media (max-width:767px) {
        flex-direction: column;
    }

    .toggle {
        margin: 0 1.5rem;
        width:68px;
        padding:5px;
        background:$color-grey;
        border-radius:33px;
        transition: background-color 500ms ease-out;

        &.active {
            background-color: $color-primary;
            .toggle-indicator {
                transform: translateX(36px);
            }
        }

        &-indicator {
            width:22px;
            height:22px;
            background-color: $brand-white;
            border-radius:33px;
            transition: transform 100ms ease-out;
        }
    }

    .label {
        font-family: $font-primary-med;
        font-size: 16px;

        @media (max-width:767px) {
            padding-left: 20px;
            padding-right: 20px;
            padding-top: 10px;
            font-size: 12px;
            text-align: center;
        }
    }
}
</style>
